/** Shared amplitude envelope for the pitched voices. */

/**
 * Exponential attack/decay. Web Audio's exponential ramps cannot reach true
 * zero, so the floor is a very small positive value rather than 0.
 */
export function env(
  gain: GainNode,
  when: number,
  attack: number,
  decay: number,
  peak: number,
): void {
  gain.gain.setValueAtTime(0.0001, when);
  gain.gain.exponentialRampToValueAtTime(Math.max(peak, 0.0002), when + attack);
  gain.gain.exponentialRampToValueAtTime(0.0001, when + attack + decay);
}
